/* ============================================================================
   Sticker studio (new-experience page) — phone app flow (portrait phones only).
   Step 1  #sxSpecs   "Design Your Sticker": the studio's own shape / size / finish /
                      quantity controls (moved in while open, so pricing, limits and
                      custom sizes work unchanged) + price + START DESIGNING.
   Step 2  editor     spec summary bar (tap to change specs), big tool tabs, canvas with
                      floating Download / Share / zoom, edit bar, price + Add to Cart.
   Styles: dev-studio-phone.css (everything is scoped to html.sx-app).
   ========================================================================== */
(function () {
  'use strict';
  var html = document.documentElement;
  var mq = window.matchMedia('(max-width:768px)');
  var root = document.getElementById('stickerStudio'); if (!root) return;
  function S() { return window._sms; }
  function $(s, r) { return (r || document).querySelector(s); }
  var NAMES = { 'die-cut': 'Die-cut', circle: 'Circle', square: 'Square', rectangle: 'Rectangle', oval: 'Oval', 'rounded-square': 'Rounded' };
  var FIN = { matte: 'Matte', glossy: 'Glossy', holographic: 'Holo' };
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var PEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';

  function hasArt() {
    var s = S(); if (!s || !s.canvas) return false;
    return s.canvas.getObjects().some(function (o) { return !o._isCutline && !o._isCutEdge && !o._isScissorIcon && !(o._isTemplateBg && o.visible === false); });
  }
  function priceText() { var t = $('#totalPriceLg'), u = $('#unitPrice'); return { t: t ? t.textContent.trim() : '', u: u ? u.textContent.trim() : '' }; }
  function sizeText(s) {
    if (s.size === 'custom') { var w = $('#smsCustomW'), h = $('#smsCustomH'), fmt = function (el) { var n = Number(el && el.value); return Number.isFinite(n) ? String(Math.round(n * 100) / 100) : ''; }; return fmt(w) + ' × ' + fmt(h) + '"'; }
    return (Number(s.sizeInches) || '') + '"';
  }
  var headerTotal=null,cartHome=null;
  function placeHeader(on){
    var actions=$('.sm-codex-actions'),cart=$('#sxCartBtn');if(!actions)return;
    if(!headerTotal){headerTotal=document.createElement('div');headerTotal.id='sxHeaderTotal';headerTotal.innerHTML='<span>Total</span><strong></strong>';actions.prepend(headerTotal);}
    headerTotal.hidden=!on;
    if(on&&cart&&cart.parentNode!==actions){cartHome={parent:cart.parentNode,next:cart.nextSibling};actions.appendChild(cart);}
    else if(!on&&cart&&cartHome&&cart.parentNode===actions){cartHome.parent.insertBefore(cart,cartHome.next&&cartHome.next.parentNode===cartHome.parent?cartHome.next:null);}
  }

  // ── step 1 ────────────────────────────────────────────────────────────────
  var specs = null, specsBody = null, goBtn = null, homes = [], open = false, touched = false;
  function buildSpecs() {
    if (specs) return;
    specs = document.createElement('div'); specs.id = 'sxSpecs'; specs.hidden = true;
    specs.setAttribute('role', 'dialog'); specs.setAttribute('aria-label', 'Choose your sticker');
    specs.innerHTML = '<div class="sxs-scroll"><div class="sxs-head"><h2>Design Your Sticker</h2><p>Choose your specs, then start designing</p></div><div class="sxs-body"></div></div>' +
      '<div class="sxs-foot"><div class="sxs-price"><b id="sxsTotal"></b><small id="sxsUnit"></small></div><button type="button" id="sxsGo"></button></div>';
    root.appendChild(specs);
    specsBody = specs.querySelector('.sxs-body'); goBtn = specs.querySelector('#sxsGo');
    goBtn.addEventListener('click', function () { closeSpecs(); });
    specs.addEventListener('pointerdown', function () { touched = true; });
  }
  function openSpecs() {
    if (open || !html.classList.contains('sx-app')) return;
    buildSpecs(); homes = [];
    root.querySelectorAll('.sms-config .sm-spec-options').forEach(function (o) {
      homes.push({ o: o, parent: o.parentNode, next: o.nextSibling });
      o.hidden = false; specsBody.appendChild(o);
    });
    // close any open drawer or popover underneath
    var x = $('#smToolPanel .sm-panel-close'), p = $('#smToolPanel'); if (p && !p.hidden && x) x.click();
    specs.hidden = false; open = true; html.classList.add('sx-specs-open');
    var sc = specs.querySelector('.sxs-scroll'); if (sc) sc.scrollTop = 0;
    refresh();
  }
  function closeSpecs() {
    if (!open) return;
    homes.forEach(function (h) { h.o.hidden = true; h.parent.insertBefore(h.o, h.next && h.next.parentNode === h.parent ? h.next : null); });
    homes = []; specs.hidden = true; open = false; html.classList.remove('sx-specs-open');
    window.dispatchEvent(new Event('resize')); // the canvas re-fits to the editor it was hidden behind
  }
  window._sxPhoneSpecs = { open: openSpecs, close: closeSpecs, isOpen: function () { return open; } };

  // ── step 2: summary bar ──────────────────────────────────────────────────
  var bar = null;
  function buildBar() {
    if (bar) return;
    var ed = root.querySelector('.sms-editor'); if (!ed) return;
    bar = document.createElement('button'); bar.type = 'button'; bar.id = 'sxSpecBar'; bar.setAttribute('aria-label', 'Change sticker specs');
    bar.innerHTML = '<span class="sxb-txt"></span><b class="sxb-price"></b><span class="sxb-edit">' + PEN + 'Edit</span>';
    ed.insertBefore(bar, ed.firstChild);
    bar.addEventListener('click', openSpecs);
  }

  function refresh() {
    var s = S(), pr = priceText();
    if(headerTotal){var total=headerTotal.querySelector('strong');if(total.textContent!==pr.t){total.textContent=pr.t;headerTotal.setAttribute('aria-label','Total '+pr.t);}}
    if (bar && s) {
      var t = sizeText(s) + ' ' + (NAMES[s.shape] || s.shape) + ' · ' + (FIN[s.finish] || s.finish) + ' · ' + Number(s.qty).toLocaleString();
      var tx = bar.querySelector('.sxb-txt'); if (tx.textContent !== t) tx.textContent = t;
      var pb = bar.querySelector('.sxb-price'); if (pb.textContent !== pr.t) pb.textContent = pr.t;
    }
    if (specs) {
      var a = $('#sxsTotal'), b = $('#sxsUnit'); if (a && a.textContent !== pr.t) a.textContent = pr.t; if (b && b.textContent !== pr.u) b.textContent = pr.u;
      var lbl = (hasArt() ? 'Continue designing' : 'Start designing');
      if (goBtn && goBtn.getAttribute('data-l') !== lbl) { goBtn.setAttribute('data-l', lbl); goBtn.innerHTML = lbl + ARROW; }
      var bad = (window._smsMOR && s && window._smsMOR.invalid(s.sizeInches, s.qty)) || ($('#totalPriceLg') && /—/.test(pr.t));
      if (goBtn) goBtn.disabled = !!bad;
    }
  }

  // ── floating Download / Share / zoom and the resolution note live on the canvas ──
  var utilHome = null, noteHome = null;
  function placeFloating(on) {
    var area = root.querySelector('.sms-canvas-area'), util = root.querySelector('.sm-canvas-utilities'), note = $('#smCodexFeedback');
    if (!area) return;
    if (on) {
      if (util && util.parentNode !== area) { utilHome = { parent: util.parentNode, next: util.nextSibling }; area.appendChild(util); }
      if (note && note.parentNode !== area) { noteHome = { parent: note.parentNode, next: note.nextSibling }; area.appendChild(note); }
    } else {
      if (util && utilHome && util.parentNode === area) utilHome.parent.insertBefore(util, utilHome.next && utilHome.next.parentNode === utilHome.parent ? utilHome.next : null);
      if (note && noteHome && note.parentNode === area) noteHome.parent.insertBefore(note, noteHome.next && noteHome.next.parentNode === noteHome.parent ? noteHome.next : null);
    }
  }

  // ── mode switch (portrait phone ↔ anything else) ─────────────────────────
  function mode() {
    var on = mq.matches;
    if (on === html.classList.contains('sx-app')) return;
    html.classList.toggle('sx-app', on);
    placeHeader(on);
    if (on) { buildBar(); placeFloating(true); }
    else { closeSpecs(); placeFloating(false); }
    refresh();
  }
  if (mq.addEventListener) mq.addEventListener('change', mode); else if (mq.addListener) mq.addListener(mode);

  // editing state: floating buttons step aside for the Done bar, text toolbar, brush bar, crop
  function vis(e) { return !!e && e.getClientRects().length > 0 && getComputedStyle(e).display !== 'none' && getComputedStyle(e).visibility !== 'hidden'; }
  setInterval(function () {
    if (!html.classList.contains('sx-app')) return;
    var cr = window._sl2CropApi;
    var ab = $('#adjustBar');
    var editing = (ab && ab.classList.contains('visible')) || vis($('#smsTextToolbar')) || vis($('#smsEraserBar')) || !!(cr && cr.isActive && cr.isActive());
    html.classList.toggle('sx-editing', !!editing);
    refresh();
  }, 300);

  // ── an open tool drawer covers the bottom of the canvas: slide (and if needed shrink) the sticker into the space above it ──
  var shiftKey = '';
  function artRect() {
    var s = S(), c = s && s.canvas; if (!c) return null;
    var up = c.upperCanvasEl.getBoundingClientRect(), k = up.width / c.getWidth(), L = 1e9, T = 1e9, R = -1e9, B = -1e9, any = false;
    c.getObjects().forEach(function (o) { if (o.visible === false || o._isScissorIcon) return; var b = o.getBoundingRect(); any = true; L = Math.min(L, b.left); T = Math.min(T, b.top); R = Math.max(R, b.left + b.width); B = Math.max(B, b.top + b.height); });
    return any ? { l: up.left + L * k, t: up.top + T * k, r: up.left + R * k, b: up.top + B * k } : null;
  }
  function fitAboveDrawer() {
    var pv = $('#previewArea'), panel = $('#smToolPanel'), area = root.querySelector('.sms-canvas-area'); if (!pv || !area) return;
    var on = html.classList.contains('sx-app') && panel && !panel.hidden && vis(panel);
    var key = on ? String(Math.round(panel.getBoundingClientRect().top / 20)) : '';
    if (key === shiftKey) return; shiftKey = key;
    if (!on) { pv.style.transform = ''; return; }
    pv.style.transition = 'none'; var old = pv.style.transform; pv.style.transform = '';
    var art = artRect(), ar = area.getBoundingClientRect(), pr = pv.getBoundingClientRect(), top = ar.top + 8, bottom = panel.getBoundingClientRect().top - 10;
    pv.style.transform = old; void pv.offsetWidth; pv.style.transition = '';
    if (!art || bottom - top < 60) { pv.style.transform = ''; return; }
    var k = Math.min(1, (bottom - top) / (art.b - art.t + 16), (ar.width - 16) / (art.r - art.l + 16));
    var cx = (art.l + art.r) / 2, cy = (art.t + art.b) / 2, dy = (top + bottom) / 2 - cy;
    pv.style.transformOrigin = (cx - pr.left) + 'px ' + (cy - pr.top) + 'px';
    pv.style.transform = 'translateY(' + Math.round(dy) + 'px) scale(' + k.toFixed(3) + ')';
  }
  setInterval(fitAboveDrawer, 200);

  // ── start ─────────────────────────────────────────────────────────────────
  function start() {
    mode();
    if (!html.classList.contains('sx-app')) return;
    var q = location.search;
    // shared designs, templates and links into a design open straight in the editor
    if (/[?&](s|share|template|tpl)=/.test(q) || hasArt()) return;
    openSpecs();
    // a design restored right after load (autosave) skips step 1, unless they've started choosing
    var t0 = Date.now(), iv = setInterval(function () {
      if (Date.now() - t0 > 5000) return clearInterval(iv);
      if (!touched && open && hasArt()) { clearInterval(iv); closeSpecs(); }
    }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
